import { SelectOptionTP } from 'main/common/components/form-fields/select/inner/types/SelectOptionTP'
import { SelectCP } from 'main/common/components/form-fields/select/SelectCP'
import { PaymentMethodEnum } from 'submodules/neritclin-sdk/services/sale/paymentconfig/enums/PaymentMethodEnum'
import React from 'react'
import styled from 'styled-components'
import { IFormItemCommonProps } from 'main/common/components/form-fields/inner/interfaces/IFormItemCommonProps'
import { FormModel } from 'main/common/form-state-manager/FormModel'
import { SaleOriginEnum, SaleOriginLabelEnum } from 'submodules/neritclin-sdk/services/sale/sale/enums/SaleOriginEnum'

interface ISelectSaleOriginCPProps<FModelTP extends FormModel = any> extends IFormItemCommonProps<FModelTP, PaymentMethodEnum> {
    allowClear?: boolean
}

/**
 * Componente para select de Origem do Pagamento.
 * OBS: Baseado em enum.
 */
export function SelectSaleOriginCP(props: ISelectSaleOriginCPProps): JSX.Element {

    const OPTIONS: SelectOptionTP[] = Object.values(SaleOriginEnum).map((saleOrigin, i) => ({
        key: `key-${i}`,
        label: SaleOriginLabelEnum[saleOrigin],
        value: saleOrigin
    }))

    return (
        <SelectWrapperSCP>
            <SelectCP
                placeholder={props.placeholder}
                label={props.label}
                value={props.value}
                disabled={props.disabled}
                required={props.required}
                formStateManager={props.formStateManager}
                selectedOptions={props.value ? [props.value] : undefined}
                fieldName={props.fieldName}
                fontSize={props.fontSize}
                isMultiple={false}
                allowClear={props.allowClear}
                options={OPTIONS}
                defaultOpen={false}
                onChange={props.onChange}
                width={props.width}
            />
        </SelectWrapperSCP>
    )
}

const SelectWrapperSCP = styled.div`
    width:100%;
`
